import SvgIcon from "../../utils/Icon";
import { ReactComponent as Notificacion } from "../../assets/icons/alarma.svg";

const Notificaciones = ({ patientId, doctorId }) => {
    //NOSE
    return (
        <>
            <h2 className="flex bg-[#1f94c2ff] font-medium text-md text-white px-7 py-5">
                <SvgIcon Icon={Notificacion} className={"w-6 h-6 text-[#205087ff] mr-3"} /> Notificaciones
            </h2>
            <div className="bg-white border-l space-y-5 border-b border-r border-[#6e787aff] p-8">

                <div className="flex flex-col sm:flex-row w-full items-start sm:items-center gap-2">
                    <span className="px-2 py-1 bg-[#f79865ff] text-[#205087ff] font-semibold rounded-md">
                        Notificación 1
                    </span>
                    <span className="px-2 py-1 bg-[#1f94c2ff] text-white flex-1 rounded-md">
                        Cita próxima con Doctor 1
                    </span>
                </div>


                <div className="flex flex-col sm:flex-row w-full items-start sm:items-center gap-2">
                    <span className="px-2 py-1 bg-[#f79865ff] text-[#205087ff] font-semibold rounded-md">
                        Notificación 1
                    </span>
                    <span className="px-2 py-1 bg-[#1f94c2ff] text-white flex-1 rounded-md">
                        Cita próxima con Doctor 1
                    </span>
                </div>


                <div className="flex flex-col sm:flex-row w-full items-start sm:items-center gap-2">
                    <span className="px-2 py-1 bg-[#f79865ff] text-[#205087ff] font-semibold rounded-md">
                        Notificación 1
                    </span>
                    <span className="px-2 py-1 bg-[#1f94c2ff] text-white flex-1 rounded-md">
                        Cita próxima con Doctor 1
                    </span>
                </div>


            </div>
        </>
    );
}

export default Notificaciones;